import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ExternalIntegration } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

const BackstageIntegrationTableNameCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ExternalIntegration>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{integration.name}</TableCellText>
    </TableSimpleCell>
  );
};

export default BackstageIntegrationTableNameCell;
